import { Component } from '@angular/core';
/*import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';*/
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'compliance',
    templateUrl: './compliance.component.html',
    styleUrls: ['./compliance.component.scss'],
    standalone: false
})
export class ComplianceComponent implements ICellRendererAngularComp {
    public _params: ICellRendererParams;
    cell: { row: any, colHeader: string };

    constructor() {
    }

    agInit(params: ICellRendererParams): void {
        this._params = params;
   
        this.cell = { row: params.value, colHeader: params.colDef.headerName };
    }

    refresh(params: any): boolean {
        return true;
    }
}
